<ng-container *ngFor="let vm of validationMessages[controlName]">
  <div *ngIf="showValidationError(vm.type)" [innerHTML]="vm.message + '.'"></div>
</ng-container>
